const messages = {
  "0": "P",
  "1": "u",
  "2": "n",
  "3": "t",
  "4": "e",
  "5": "n",
  "availPoints": "Beschikbare punten",
  "awaitingPoints": "Punten nog niet beschikbaar",
  "board": {
    "title": "Dashboard",
    "title2": "Puntensaldo {year}",
    "headline1": "Uw acties en uw punten in één oogopslag",
    "headline2": "Verdien punten voor uw banden aankopen.",
    "pointsBalanceToDate": "HUIDIG PUNTENSALDO",
    "availPoints": "Beschikbare punten",
    "awaitingPoints": "Punten in behandeling",
    "yourRealisation": "UW PRESTATIES",
    "yourEngagement": "Uw jaarlijkse target: <b>{tyres} banden</b>",
    "yourPoints": "UW PUNTEN",
    "yourRetailPurchase": "UW AANKOPEN IN DETAIL",
    "yourRetailPurchaseCCS": "UW VERKOPEN IN DETAIL",
    "pointsByPurchase": "Punten gegenereerd door uw aankopen",
    "pointsByBoosters": "Punten gegenereerd door boosters",
    "pointsByBSPurchase": "Punten gegenereerd door uw aankopen bij Bridgestone",
    "pointsByBSPurchaseCCS": "Punten gegenereerd door uw verkoop van Bridgestone banden",
    "remaining": "BANDEN RESTEREND",
    "yourGoal": "Voortgang richting doel",
    "unit": "banden",
    "buttons": {
      "learnMore": "Meer informatie over uw punten",
      "learnMoreAboutMechanism": "Meer informatie over de werking"
    },
    "charts": {
      "byBrand": "Per merk",
      "bySize": "Per velgmaat"
    },
    "exploreResults": "Ontdek uw resultaten",
    "tyreLimitInfo": "Een sell-out volume van minimaal 50 banden van de merken Bridgestone en/of Firestone is vereist voor elke periode van de Booster-actie"
  },
  "charts": {
    "byBrand": "Per merk",
    "bySize": "Per velgmaat"
  },
  "dashboard": {
    "dashboardTitle": "Uw voordelen",
    "dashboardBox": {
      "title": "Puntensaldo",
      "description": "Uw huidige aantal marketingpunten",
      "availPoints": "Beschikbare punten",
      "awaitingPoints": "Punten nog niet beschikbaar",
      "lastUpdate": "Laatste update",
      "button": "Meer informatie",
      "points": "punten"
    }
  },
  "soldTyres": "VERKOCHTE BANDEN",
  "receivedPoints": "VERDIENDE PUNTEN",
  "sharePointModal": {
    "header": "Deel uw punten",
    "forShare": "Punten die u deelt"
  },
  "notFoundFile": "Geen bestand geselecteerd",
  "chooseFile": "Kies een bestand"
};

export default {
  messages,
};
